// src/services/authApi.ts
import axios from "axios";

// const API_BASE = "http://localhost:2025";
const API_BASE = "https://www.projectinfotech.in";

const api = axios.create({
  baseURL: `${API_BASE}/api/auth`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function signup(payload: { name: string; mobile: string; email: string }) {
  return api.post("/signup", payload);
}

export async function sendOtp(identifier: string) {
  return api.post("/send-otp", { identifier });
}

export async function verifyOtp(identifier: string, otp: string) {
  return api.post("/verify-otp", { identifier, otp });
}

// For completing google signup (if backend exposes this endpoint)
export async function completeGoogleMobile(email: string, mobile: string) {
  // Optional: implement on backend as /api/auth/complete-google (PATCH or POST)
  return api.post("/complete-google", { email, mobile });
}


// Ek file banayein user login data ko manage karne ke liye
const USER_INFO_KEY = 'userInfo';

export const saveUser = (user: { name: string; email: string; token: string }) => {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(user));
};

export const getUser = () => {
  const userInfo = localStorage.getItem(USER_INFO_KEY);
  return userInfo ? JSON.parse(userInfo) : null;
};

export const removeUser = () => {
  localStorage.removeItem(USER_INFO_KEY);
};